import type {
  PaymentMethodCheckoutCollection,
  PaymentMethodCheckoutField,
  PaymentMethodCheckoutFields,
  PaymentMethodCheckoutRequirement,
  PaymentMethodFieldCapability,
} from '../api/types'

export type PaymentCapabilityField = PaymentMethodCheckoutField
export type PaymentCapabilityRequirement = PaymentMethodCheckoutRequirement
export type PaymentCapabilityCollection = PaymentMethodCheckoutCollection
export type PaymentFieldCapability = PaymentMethodFieldCapability
export type PaymentMethodFieldCapabilities = PaymentMethodCheckoutFields

export function getPaymentFieldCapability(
  fields: PaymentMethodCheckoutFields | null | undefined,
  field: PaymentMethodCheckoutField
): PaymentMethodFieldCapability | undefined {
  return fields?.[field]
}

export function isPaymentFieldRequiredInCheckout(params: {
  fields: PaymentMethodCheckoutFields | null | undefined
  field: PaymentMethodCheckoutField
  country?: string | null
}): boolean {
  const capability = getPaymentFieldCapability(params.fields, params.field)
  if (!capability || capability.collection !== 'checkout_form') {
    return false
  }

  if (capability.requirement === 'required') {
    return true
  }

  if (capability.requirement !== 'conditional') {
    return false
  }

  const country = params.country?.trim().toUpperCase()
  return !!country && !!capability.required_countries?.includes(country)
}

export function shouldCollectPaymentFieldInCheckout(params: {
  fields: PaymentMethodCheckoutFields | null | undefined
  field: PaymentMethodCheckoutField
}): boolean {
  const capability = getPaymentFieldCapability(params.fields, params.field)
  if (!capability) {
    return false
  }

  return (
    capability.collection === 'checkout_form' &&
    capability.requirement !== 'not_collected' &&
    capability.requirement !== 'provider_auto'
  )
}
